import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    size?: number;
};

const FloorArrowIcon = ({ size = 26, ...props }: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 26 26"
            fill="none"
            {...props}
        >
            <rect width="26" height="26" rx="13" fill="#67615D" fillOpacity="0.2" />
            <path
                d="M11.6529 6.96429L10.2144 8.25862L14.6573 12.8156L10.2144 17.7347L11.6529 19.0357L17.2661 12.8223L11.6529 6.96429Z"
                fill="#F4F4F4"
            />
        </svg>
    );
};

export default FloorArrowIcon;